export const CALENDAR_TYPE = {
    appointment: {
        color: '#db23b2',
        backgroundColor: '#e3bbda',
        label: 'General Appointment',
        className: 'FuneralManagerAppointment',
        type: 'Appointment'
    },
    prefuneral: {
        color: '#4f3fc0',
        backgroundColor: '#b8bff3',
        label: 'Pre-Funeral Appointment',
        className: 'FuneralManagerAppointment',
        type: 'PreFuneral'
    },
    arrangement: {
        color: '#bab821',
        backgroundColor: '#f4edbe',
        label: 'Arrangement',
        className: 'FuneralManagerAppointment',
        type: 'Arrangement'
    },
    viewing: {
        color: '#1f9bc9',
        backgroundColor: '#cde5f0',
        label: 'Viewing',
        className: 'FuneralManagerFuneralPlaceOfViewing',
        type: 'Viewing'
    },
    service: {
        color: '#26cc6f',
        backgroundColor: '#b8ecd1',
        label: 'Service',
        className: 'FuneralManagerFuneralPlaceOfService',
        type: 'Service'
    },
    committal: {
        color: '#e67d40',
        backgroundColor: '#f4dfd5',
        label: 'Committal',
        className: 'FuneralManagerFuneralDisposal',
        type: 'Committal'
    },
    disposal: {
        color: '#b89020',
        backgroundColor: '#ece0c1',
        label: 'Disposal',
        className: 'FuneralManagerFuneralDisposal',
        type: 'Disposal'
    },
    refreshments: {
        color: '#9840e6',
        backgroundColor: '#d1c0e4',
        label: 'Refreshments',
        className: 'FuneralManagerRefreshmentsVenue',
        type: 'Refreshments'
    },
    reflection: {
        color: '#1f9bc9',
        backgroundColor: '#cde5f0',
        label: 'Viewing Room Booking',
        className: 'FuneralManagerReflectionRoom',
        type: 'ReflectionRoom'
    },
    ashCollection: {
        color: '#736d56',
        backgroundColor: '#dddcd5',
        label: 'Ashes Collection',
        className: 'FuneralManagerAppointment',
        type: 'AshCollection'
    },
    unavailableStaff: {
        color: '#e64343',
        backgroundColor: '#f5d4d6',
        label: 'Staff Unavailable',
        className: 'FuneralManagerAppointment',
        type: 'Unavailable'
    },
    unavailableLocation: {
        color: '#e64343',
        backgroundColor: '#f5d4d6',
        label: 'Location Unavailable',
        className: 'FuneralManagerCalendarEvent',
        type: 'VenueUnavailable'
    }
};

export const CALENDAR_TYPES = Object.values(CALENDAR_TYPE);

export function getCalendarCategoryByClassName(className, crematedOrBuried) {
    let t = CALENDAR_TYPES.find(
        h =>
            h.className === className &&
            (!!crematedOrBuried ? h.type === ('Cremated' === crematedOrBuried ? 'Disposal' : 'Committal') : true)
    );
    if (t) return t;
    return CALENDAR_TYPES.find(h => h.type === 'VenueUnavailable');
}

export function getCalendarCategoryByType(type) {
    let t = CALENDAR_TYPES.find(h => h.type === type);
    if (t) return t;
    return CALENDAR_TYPES.find(h => h.type === 'Unavailable');
}

export const APPOINTMENT_OPTIONS = [
    { label: 'General Appointment', value: 'Appointment', type: 'Appointment' },
    { label: 'Staff Unavailable', value: 'Unavailable', type: 'Appointment' },
    { label: 'Ash Collection', value: 'AshCollection', type: 'Appointment' },
    { label: 'Viewing Room', value: 'ReflectionRoom', type: 'StaffAllocation' }
];

export function getAppointmentOptionType(value) {
    let t = APPOINTMENT_OPTIONS.find(h => h.value === value);
    if (t) return t.type;
    return 'Appointment';
}

export const appointmentTypesByView = ({ type, view }) => {
    return view !== 'Locations'
        ? ['Appointment', 'Unavailable', 'AshCollection', 'ReflectionRoom'].indexOf(type) > -1
        : ['Service', 'Disposal', 'Committal', 'Refreshments', 'Viewing', 'VenueUnavailable'].indexOf(type) > -1;
};
